/**
 * Shopify token patterns
 *
 * App secret keys: `shpss_` followed by 32-64 alphanumeric characters
 * Source: https://shopify.dev/changelog/app-secret-key-length-has-increased for app secret keys
 *
 * Public apps: `shpat_` followed by 32-64 alphanumeric characters
 * Source: https://shopify.dev/changelog/length-of-the-shopify-access-token-is-increasing
 *
 * Custom apps: `shpca_` followed by 32-64 alphanumeric characters
 * Legacy private apps: `shppa_` followed by 32-64 alphanumeric characters
 */
export const shopifyToken = /(shppa|shpca|shpat|shpss)_[a-zA-Z0-9]{32,64}/;
